/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { localizationListSchema } from "./localizationListSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";

export const productCategorySchema = z.object({
	id: z.uuid(),
	name: z.string().max(255),
	tags: z.array(z.string()),
	adult: z.boolean().optional(),
	loc_tags: localizationListSchema.describe("Util serializer for representation in swagger"),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
});
